import { Component, ChangeDetectionStrategy } from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {FeatureService} from "../../shared/modules/feature/feature.service";
import {environment} from "../../../environments/environment";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-product-registration',
  templateUrl: './product-registration.component.html',
  styleUrl: './product-registration.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ProductRegistrationComponent {
  isocode: string = '';
  constructor(
    public translate: TranslateService,
    public feature: FeatureService,
    private route: ActivatedRoute,
  ) {
    this.isocode =  translate.currentLang ?? 'en';
    this.route.queryParams.subscribe((params) => {
      let paramString = '';
      const part = params['partNumber'];

      if (part !== undefined) {
        if (Array.isArray(part)) {
          (part as string[]).forEach((p, idx) => {
            paramString += `${idx === 0 ? '?' : '&'}partNumber=${encodeURIComponent(p)}`;
          });
        } else {
          paramString = `?partNumber=${encodeURIComponent(part as string)}`;
        }
      }

      if (this.isocode === 'en') {
        window.location.href = environment.productRegistrationPages['INT'] + paramString;
      } else {
        const page = environment.productRegistrationPages[this.isocode] ?? environment.productRegistrationPages['INT'];
        window.location.href = page + paramString;
      }
    });

  }
}
